


















































import { DocumentType } from "@/enums/enums";
import { OnlineViewModel } from "@/model/document/documentModel";
import { UserModel } from "@/model/user/userModel";
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { version } from "../../../package.json";

const StoreAuthentication = namespace("Authentication");
const StoreDocument = namespace("Document");
@Component
export default class Footer extends Vue {
  @Prop({ default: false }) isAuthorized!: boolean;
  @Prop({ default: false }) isNotMerchant!: boolean;
  @Prop({ default: 0 }) transactionType!: number;

  @StoreAuthentication.Getter
  private getUserInfo!: UserModel | null;
  @StoreDocument.Getter
  private getDocumentDetail!: OnlineViewModel | null;
  private version = version;

  private widthScreen = 0;

  get createdDateTime() {
    if (this.getDocumentDetail && this.getDocumentDetail?.document.data.createdDateTime && !this.isDocumentOtherType) {
      return this.GetDateTimeFormat(this.getDocumentDetail?.document.data.createdDateTime);
    } else {
      return null;
    }
  }

  get updatedDateTime() {
    if (this.getDocumentDetail && this.getDocumentDetail?.document.data.updatedDateTime && !this.isDocumentOtherType) {
      return this.GetDateTimeFormat(this.getDocumentDetail?.document.data.updatedDateTime);
    } else {
      return null;
    }
  }

  get isDocumentOtherType() {
    return this.transactionType === DocumentType.Envelope || this.transactionType === DocumentType.ExecutiveSummary;
  }

  mounted() {
    this.widthScreen = window.innerWidth;
    window.addEventListener("resize", () => {
      this.widthScreen = window.innerWidth;
    });
  }

  public GetDateTimeFormat(_date: any) {
    let newDate = new Date(_date);
    newDate = new Date(newDate.getTime() - newDate.getTimezoneOffset() * 60000);

    let fullYear = newDate.getFullYear().toString();
    let month = (newDate.getMonth() + 1).toString();
    let date = newDate.getDate().toString();
    let hours = newDate.getHours().toString();
    let minutes = newDate.getMinutes().toString();
    let seconds = newDate.getSeconds().toString();

    if (fullYear === "1" && month === "1" && date === "1") {
      return "N/A";
    }

    return `${fullYear}.${month.length == 2 ? month : "0" + month}.${date.length == 2 ? date : "0" + date} ${
      hours.length == 2 ? hours : "0" + hours
    }:${minutes.length == 2 ? minutes : "0" + minutes}:${seconds.length == 2 ? seconds : "0" + seconds}`;
  }

  public RedirectToPEAK() {
    window.open("https://peakaccount.com/main.html");
  }
  public RedirectToRegister() {
    window.open(`${process.env.VUE_APP_PeakAccount}register/select_register`);
  }
}
